import { JobApplication } from '../models/job-application.model';

export function buildCandidateTemplateContext(
  application: JobApplication
): Record<string, string> {
  return {
    candidateName: application.fullname || String(application.candidate || ''),
    jobUrl: application.job?.url || '',
    jobApplicationUrl: (application.job as { url?: string })?.url || '',
    jobTitle: application.job?.name || application.jobName || '',
    companyName: application.job?.owner?.companyName || '',
    recruiterName:
      application.job?.owner?.fullname || application.ownerFullname || '',
    recruiterEmail: application.job?.owner?.email || '',
    clientName: application.job?.client?.name || application.client || '',
    notes: '',
  };
}

export function populateNotificationTemplate(
  template: string,
  data: Record<string, string>
): string {
  return template.replace(/\$\{(\w+)\}/g, (_, key) => data[key] || '');
}

/**
 * Converts the supported email-brand FreeMarker macros into browser-editable HTML.
 *
 * The backend owns final FreeMarker rendering. This conversion is only for the
 * recruiter composer, where raw directives would otherwise be shown as message text.
 */
export function prepareNotificationTemplateForEditing(
  template: string,
  data: Record<string, string>
): string {
  const populated = populateNotificationTemplate(template, data);

  return populated
    .replace(/<#import\s+["'][^"']+["']\s+as\s+\w+\s*>/gi, '')
    .replace(/<@brand\.layout\b[^>]*>/gi, '')
    .replace(/<\/@brand\.layout\s*>/gi, '')
    .replace(/<@brand\.p\s*>/gi, '<p>')
    .replace(/<\/@brand\.p\s*>/gi, '</p>')
    .replace(
      /<@brand\.link\s+href=["']([^"']*)["']\s*>([\s\S]*?)<\/@brand\.link\s*>/gi,
      '<a href="$1">$2</a>'
    )
    .replace(
      /<@brand\.button\s+href=["']([^"']*)["']\s+label=["']([^"']*)["']\s*\/>/gi,
      '<p><a href="$1">$2</a></p>'
    )
    .trim();
}

export function stripHtmlTags(html: string): string {
  return html.replace(/<[^>]*>/g, '');
}

export function getPlainTextFromNote(note?: string): string {
  if (!note) {
    return '';
  }
  try {
    const parsed = JSON.parse(note);
    if (typeof parsed === 'object' && parsed.content) {
      return stripHtmlTags(String(parsed.content));
    }
    return stripHtmlTags(typeof parsed === 'string' ? parsed : note);
  } catch {
    return stripHtmlTags(note);
  }
}

export function hasRichTextContent(note?: string): boolean {
  return getPlainTextFromNote(note).trim().length > 0;
}
